export default {
  bind(el, binding, vnode) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (SELECTWRAP_DOM) {
      SELECTWRAP_DOM.addEventListener('scroll', function() {
        const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (condition) {
          binding.value();
        }
      });
    } else {
      // 如果使用了popper-append-to-body，或者下拉框是懒加载的
      // 尝试通过组件实例获取
      const select = vnode.componentInstance;
      if (select) {
        select.$on('visible-change', (val) => {
          if (val) {
            select.$nextTick(() => {
              // 通过refs获取下拉框DOM
              // el-select 内部引用了 popper (ElSelectDropdown) -> scrollbar (ElScrollbar) -> wrap
              const popper = select.$refs.popper;
              if (popper && popper.$el) {
                const wrap = popper.$el.querySelector('.el-select-dropdown__wrap');
                if (wrap) {
                  // 防止重复绑定
                  if (wrap.getAttribute('data-loadmore-bound')) return;
                  
                  wrap.addEventListener('scroll', function() {
                    const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                    if (condition) {
                      binding.value();
                    }
                  });
                  wrap.setAttribute('data-loadmore-bound', 'true');
                }
              }
            });
          }
        });
      }
    }
  }
};
